import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Typography, Card, Space, Divider, Button, Row, } from 'antd';
// request
import { getOrderSummary } from 'requests/statistic'

const { Title } = Typography;

const OverviewCardOrders = (props) => {
	const [data, setData] = useState({});

	useEffect(() => {
		const getData = async () => {
			const response = await getOrderSummary();
			setData(response);
		}

		getData();
	}, []);

	return (
		<Card className="overview-orders">
			<Title level={3}>Orders</Title>
			<Divider />
			<Row justify="space-between" align='middle' className='mb-16'>
				<Row justify="start" align='middle'>
					<Space
						size={{ sx: 0, md: 1 }}
						direction="vertical"
						align="center"
						className="weight-7 count-list red-box"
					>
						<span>{data.shipped_awaiting_payment_count || 0}</span>
						<span className="">Orders</span>
					</Space>
					<span className="ml-16 weight-5">Not paid, to be shipped</span>
				</Row>
				<Link to='/orders?fulfillment_status=1%2C2&payment_status=1'>
					<Button>
						<span className="list-button">Open to process</span>
					</Button>
				</Link>
			</Row>
			<Row justify="space-between" align='middle' className='mb-16'>
				<Row justify="start" align='middle'>
					<Space
						size={{ sx: 0, md: 1 }}
						direction="vertical"
						align="center"
						className="weight-7 count-list green-box"
					>
						<span>{data.shipped_paid_count || 0}</span>
						<span className="">Orders</span>
					</Space>
					<span className="ml-16 weight-5">Paid, to be shipped</span>
				</Row>
				<Link to='/orders?fulfillment_status=1%2C2&payment_status=2'>
					<Button>
						<span className="list-button">Open to process</span>
					</Button>
				</Link>
			</Row>
			<Row justify="space-between" align='middle'>
				<Row justify="start" align='middle'>
					<Space
						size={{ sx: 0, md: 1 }}
						direction="vertical"
						align="center"
						className="weight-7 count-list orange-box"
					>
						<span>{data.processing_count || 0}</span>
						<span className="">Orders</span>
					</Space>
					<span className="ml-16 weight-5">Fullfilment in process</span>
				</Row>
				<Link to='/orders?fulfillment_status=2'>
					<Button key="action-list">
						<span className="list-button">Open to ship</span>
					</Button>
				</Link>
			</Row>
		</Card>
	);
}

OverviewCardOrders.propTypes = {};

export default OverviewCardOrders;
